import { useState } from 'react'

import { helpDeskUrl } from '@/constants'
import { useClipboard } from '@/hooks'
import {
	faCheck,
	faChevronRight,
	faChevronUp,
	faCloudSlash,
	faCopy,
	faRefresh,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Collapse, Divider, Stack, TextField, Typography, useTheme } from '@mui/material'

export default function ServiceUnavailable() {
	const theme = useTheme()
	const [helpVisible, setHelpVisible] = useState(false)

	return (
		<Stack gap={2} alignItems="center" mt="5rem">
			<FontAwesomeIcon
				icon={faCloudSlash}
				fontSize={86}
				color={theme.palette.secondary.main}
				style={{ paddingLeft: '3px' }}
			/>
			<Stack>
				<Typography variant="h6" sx={{ textAlign: 'center', color: theme.palette.primary.main }}>
					Can&apos;t connect to Artemis
				</Typography>
				<Typography sx={{ textAlign: 'center', fontWeight: 'bold' }} variant="h6">
					Open Pritunl and connect to the VPN, then click Retry.
				</Typography>
			</Stack>

			<Button
				size="large"
				variant="contained"
				color="primary"
				onClick={() => window.location.reload()}
				startIcon={<FontAwesomeIcon icon={faRefresh} />}
				sx={{
					py: 1.5,
				}}
			>
				Retry
			</Button>

			<Divider sx={{ width: '32rem' }} />

			<Stack
				direction="row"
				alignItems="center"
				justifyContent="center"
				onClick={() => setHelpVisible(!helpVisible)}
				sx={{ cursor: 'pointer' }}
			>
				<Typography variant="body1" color="info" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
					Still can&apos;t connect? (usually a one-time fix)
				</Typography>
				<FontAwesomeIcon
					icon={helpVisible ? faChevronUp : faChevronRight}
					color={theme.palette.info.main}
				/>
			</Stack>

			<Instructions visible={helpVisible} />

			<Stack>
				<Typography variant="body2" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
					Still need Help?
				</Typography>
				<Typography
					variant="body2"
					color="info"
					sx={{ textAlign: 'center' }}
					href={helpDeskUrl}
					component="a"
					target="_blank"
				>
					Contact Support
				</Typography>
			</Stack>
		</Stack>
	)
}

function Instructions({ visible }: { visible: boolean }) {
	const { copy, copied } = useClipboard()

	return (
		<Collapse in={visible}>
			<Stack gap={2}>
				<Typography variant="body2">
					1 - Click the copy button below, then paste this into Chrome&apos;s address bar and hit
					enter.
				</Typography>
				<Stack direction="row" alignItems="center" spacing={2}>
					<TextField size="small" value="chrome://settings" variant="outlined" disabled />
					<Button
						size="small"
						variant="contained"
						color={copied ? 'success' : 'primary'}
						onClick={() => copy('chrome://settings')}
						sx={{ height: 'fit-content', py: 1.5, width: '6.625rem' }}
						startIcon={<FontAwesomeIcon icon={copied ? faCheck : faCopy} />}
					>
						{copied ? 'Copied!' : 'Copy'}
					</Button>
					<Typography variant="caption" color="secondary">
						Click copy then paste in a new browser tab
					</Typography>
				</Stack>

				<Typography variant="body2">
					2 - Search for “artemis”. The results should show a item for Privacy and security &gt;
					Site settings.
				</Typography>
				<Typography variant="body2">3 - Open the Site settings.</Typography>
				<Typography variant="body2">
					4 - Find “artemis.buyersedgedata.com” and open the entry.
				</Typography>
				<Typography variant="body2">5 - Look for “Local Network” and set to allow.</Typography>

				<Typography sx={{ textAlign: 'center', fontWeight: 'bold' }} variant="body1">
					After updating your settings, return here and click Retry.
				</Typography>
			</Stack>
		</Collapse>
	)
}
